module.exports = __webpack_public_path__ + "static/media/A3.e724dc60.png";